var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import { fabric } from "fabric";
import { boundedCanvas, scalableCanvas, filterableCanvas, fourDimensionalCanvas } from "../../Misc/CanvasDecorators";
import { guid } from "../../Misc/Utils";
import { TEXT_TOOLBAR } from "../Types";
import * as EditorContext from "../EditorContext";
import * as OverlayContext from "../OverlayContext";
import injectContextMenu from "./EditorMenu";
var I_TEXT = "i-text";

var Canvas = function (_React$Component) {
  _inherits(Canvas, _React$Component);

  function Canvas() {
    var _temp, _this, _ret;

    _classCallCheck(this, Canvas);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.triggerChangedEvent = function () {
      _this.canvas.filter(function (object) {
        return object.type !== I_TEXT || object.text.length > 0;
      });

      _this.canvas.scale(1);

      var scale = _this.props.EditorContext.state.video.scale;
      var overlayChangedHandler = _this.props.overlayChangedHandler;

      if (overlayChangedHandler) {
        overlayChangedHandler(_this.serialize());
      }

      _this.canvas.scale(scale);
    }, _this.serialize = function () {
      return _this.canvas.toJSON(["metadata"]);
    }, _this.tryToLoadFontSettings = function () {
      if (_this.canvas.getActiveObjects().length !== 1) {
        return;
      }

      var item = _this.canvas.getActiveObjects()[0];

      if (!item.text) {
        return;
      }

      var EditorContext = _this.props.EditorContext;
      var fill = item.fill,
          fontSize = item.fontSize,
          fontFamily = item.fontFamily,
          lineHeight = item.lineHeight,
          fontWeight = item.fontWeight,
          fontStyle = item.fontStyle;
      EditorContext.setFontSettings({
        fill: fill,
        fontSize: fontSize,
        fontFamily: fontFamily,
        lineHeight: lineHeight,
        fontWeight: fontWeight,
        fontStyle: fontStyle
      });
    }, _this.clickEventHandler = function (e) {
      _this.props.hideContextMenu();

      if (e.button === 3) {
        if (e.target === null) {
          // right-click on the canvas, do nothing
          return;
        } // right mouse click on the item, display context menu


        var selectedOverlay = _this.canvas.getObjects().find(function (overlay) {
          return overlay.metadata.id === e.target.metadata.id;
        });

        _this.props.showContextMenu(e.e, selectedOverlay, _this.canvas, _this.triggerChangedEvent);

        _this.canvas.setActiveObject(selectedOverlay);

        _this.canvas.renderAll();

        return;
      }

      if (_this.canvas.getActiveObjects().length > 0) {
        //object selected, don't do anything
        return;
      }

      var _this$props = _this.props,
          EditorContext = _this$props.EditorContext,
          OverlayContext = _this$props.OverlayContext;
      var _EditorContext$state = EditorContext.state,
          selectedToolbar = _EditorContext$state.selectedToolbar,
          fontSettings = _EditorContext$state.fontSettings;

      if (selectedToolbar !== TEXT_TOOLBAR) {
        return;
      }

      EditorContext.pauseVideo();
      OverlayContext.editItemTimeSettings(null, function (start, duration) {
        var _e$pointer = e.pointer,
            x = _e$pointer.x,
            y = _e$pointer.y;
        var text = new fabric.IText("", fontSettings);
        text.set({
          left: x,
          top: y,
          metadata: {
            id: guid(),
            start: start,
            duration: duration
          }
        });

        _this.canvas.add(text);

        _this.canvas.setActiveObject(text);

        text.enterEditing();
      });
    }, _this.changeItemMetadata = function (id, metadata) {
      _this.canvas.getObjects().forEach(function (object) {
        if (object.metadata && object.metadata.id === id) {
          object.set({
            metadata: _extends({}, metadata, {
              id: id
            })
          });
        }
      });

      _this.triggerChangedEvent();
    }, _this.deleteItemById = function (id) {
      _this.canvas.getObjects().forEach(function (object) {
        if (object.metadata && object.metadata.id === id) {
          _this.canvas.remove(object);
        }
      });

      _this.triggerChangedEvent();
    }, _this.initializeCanvas = function (canvas) {
      fabric.Object.NUM_FRACTION_DIGITS = 10;
      _this.canvas = filterableCanvas(fourDimensionalCanvas(scalableCanvas(boundedCanvas(new fabric.Canvas(canvas, {
        fireRightClick: true
      })))));

      _this.canvas.on("object:modified", _this.triggerChangedEvent);

      _this.canvas.on("mouse:down", _this.tryToLoadFontSettings);

      _this.canvas.on("mouse:up", _this.clickEventHandler);

      _this.props.OverlayContext.setCanvas(_this);
    }, _this.canvasInitialized = false, _this.canvasItemsInitialized = false, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Canvas.prototype.addImage = function addImage(url, x, y, start, duration) {
    var _this2 = this;

    fabric.Image.fromURL(url, function (img) {
      _this2.canvas.scale(1);

      img.width > img.height ? img.scaleToWidth(175) : img.scaleToHeight(175);
      img.set({
        left: x,
        top: y,
        metadata: {
          id: guid(),
          start: start,
          duration: duration
        }
      });

      _this2.canvas.add(img);

      _this2.canvas.scale(_this2.props.EditorContext.state.video.scale);

      _this2.canvas.setActiveObject(img);

      _this2.triggerChangedEvent();
    });
  };

  Canvas.prototype.handleFontSettingsChange = function handleFontSettingsChange() {
    var fontSettings = this.props.EditorContext.state.fontSettings;
    var hasFontChanges = false;
    this.canvas.getActiveObjects().forEach(function (object) {
      if (object.type === I_TEXT) {
        var oldState = JSON.stringify(object.toJSON());
        object.set(fontSettings);
        var newState = JSON.stringify(object.toJSON());
        hasFontChanges = hasFontChanges || oldState !== newState;
      }
    });

    if (hasFontChanges) {
      this.canvas.renderAll();
      this.triggerChangedEvent();
    }
  };

  Canvas.prototype.deleteSelectedObjects = function deleteSelectedObjects() {
    var _this3 = this;

    this.canvas.getActiveObjects().forEach(function (object) {
      _this3.canvas.remove(object);
    });
    this.canvas.discardActiveObject();
    this.triggerChangedEvent();
  };

  Canvas.prototype.componentDidMount = function componentDidMount() {
    var refCallback = this.props.refCallback;

    if (refCallback) {
      refCallback(this);
    }
  };

  Canvas.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this4 = this;

    if (!this.canvas) {
      return;
    }

    var _props = this.props,
        EditorContext = _props.EditorContext,
        OverlayContext = _props.OverlayContext;
    var video = EditorContext.state.video;

    if (!video.props || !video.props.width) {
      return;
    }

    if (!this.canvasInitialized) {
      var _video$props = video.props,
          width = _video$props.width,
          height = _video$props.height;
      this.canvas.setWidth(width);
      this.canvas.setHeight(height);
      this.canvasInitialized = true;
    }

    if (this.canvasInitialized && !this.canvasItemsInitialized && !this.busy) {
      var _OverlayContext$state = OverlayContext.state,
          overlay = _OverlayContext$state.overlay,
          currentTime = _OverlayContext$state.currentTime;

      if (overlay) {
        this.canvas.lowerCanvasEl.style.display = "none";
        this.canvas.scale(1);
        this.busy = true;
        this.canvas.loadFromJSON(overlay, function () {
          _this4.canvas.lowerCanvasEl.style.display = null;

          _this4.canvas.alignToTime(currentTime);

          _this4.canvasItemsInitialized = true;
          _this4.busy = false;

          _this4.canvas.scale(video.scale);
        });
        return;
      } else {
        this.canvasItemsInitialized = true;
      }
    }

    if (this.canvasItemsInitialized) {
      this.canvas.alignToTime(OverlayContext.state.currentTime);
      this.canvas.scale(video.scale);
    }

    this.handleFontSettingsChange();
  };

  Canvas.prototype.render = function render() {
    return React.createElement("canvas", {
      ref: this.initializeCanvas,
      onKeyDown: this.handleKeyDown
    });
  };

  return Canvas;
}(React.Component);

Canvas.propTypes = process.env.NODE_ENV !== "production" ? {
  EditorContext: PropTypes.object.isRequired,
  OverlayContext: PropTypes.object.isRequired,
  refCallback: PropTypes.func,
  overlayChangedHandler: PropTypes.func,
  showContextMenu: PropTypes.func,
  hideContextMenu: PropTypes.func
} : {};
export default OverlayContext.consumeContext(EditorContext.consumeContext(injectContextMenu(Canvas)));